import { render, staticRenderFns } from "./CardMudanca.vue?vue&type=template&id=ca430512&scoped=true"
import script from "./CardMudanca.vue?vue&type=script&setup=true&lang=js"
export * from "./CardMudanca.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca430512",
  null
  
)

export default component.exports